/**
 * localStorage is not always usable: it throws in Safari private browsing, when
 * cookies are blocked, and on file:// in some browsers. Every access goes
 * through these helpers so a storage failure degrades to in-memory state
 * instead of breaking the feature.
 */
export function readStorage(key) {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

export function writeStorage(key, value) {
  try {
    localStorage.setItem(key, value);
    return true;
  } catch {
    return false;
  }
}
